<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="70%">
            <v-toolbar dark color="secondary" style="border: 1px solid #07ad2d">
                <v-toolbar-title><b>Signup For {{selected_cover}}</b></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card>
                <v-card-text>
                    <v-row>
                        <!-- <v-col cols="12" sm="12">
                            <h2>Your Details</h2>
                        </v-col> -->
                        <v-col cols="12" sm="12">
                            <div>Please capture your details below. And a representative will be in touch with you to discuss further details</div>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                v-model="prospect.main.name"
                                ref="name_field"
                                color="secondary"
                                label="Name"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                v-model="prospect.main.surname"
                                ref="surname_field"
                                color="secondary"
                                label="Surname"
                                required
                            ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="2">
                            <v-select
                                v-model="prospect.main.marital_status"
                                :items="['Single', 'Married', 'Divorced']"
                                color="secondary"
                                label="Marital Status"
                                required
                            ></v-select>
                        </v-col> -->
                        <v-col cols="12" sm="4">
                            <v-text-field
                                v-model="prospect.main.phone"
                                color="secondary"
                                label="Phone Number"
                                type="number"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="12" sm="12">
                            <h2>Your Dependents (Maximum 9)</h2>
                        </v-col>
                    </v-row> -->

                    <!-- <v-row
                        style="background:#468f9fa3; padding-bottom:10px"
                        v-for="dependent in prospect.dependents"
                        :key="dependent.id"
                    >
                        <v-col cols="4" sm="4">
                            <v-text-field
                                v-model="dependent.name"
                                ref="name_field"
                                color="secondary"
                                label="Name"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4">
                            <v-text-field
                                v-model="dependent.surname"
                                ref="surname_field"
                                color="secondary"
                                label="Surname"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4">
                            <v-text-field
                                v-model="dependent.id_number"
                                ref="id_number_field"
                                color="secondary"
                                label="ID Number"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row> -->


                    <!-- Buttons for Adding/Removing Contact -->
                    <!-- <v-row style="background:#468f9fa3">
                        <v-col cols="6" sm="10" md="8"></v-col>
                        <v-col cols="3" sm="1" md="2">
                            <v-tooltip bottom v-if="prospect.dependents.length > 1">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="mx-2"
                                        color="primary"
                                        small
                                        v-on="on"
                                        @click="removeDependent()"
                                    >
                                        <v-icon>remove</v-icon>
                                    </v-btn>
                                </template>
                                <span>Remove Dependent</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="3" sm="1" md="2">
                            <v-tooltip bottom v-if="prospect.dependents.length < 9">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        color="primary"
                                        small
                                        v-on="on"
                                        @click="addDependent()"
                                    >
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </template>
                                <span>Add Another Dependent</span>
                            </v-tooltip>
                        </v-col>
                    </v-row> -->

                    <v-row v-if="submitting">
                        <v-col cols="12" sm="11" md="12">
                            <h3>Submitting your details ...</h3>
                            <v-progress-linear
                                color="green"
                                class="mb-0"
                                height="5"
                                indeterminate
                                :active="submitting"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-text class="text-center">
                    
                </v-card-text>

                <!-- Button Section -->
                <v-card-actions>
                    <v-btn
                        style="color: white"
                        large
                        color="#ff5200"
                        @click="closeDialog()"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        large
                        color="success"
                        @click="submitToServer()"
                    >
                        Signup
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>

import { emitAlert, emitSuccess, submitToBackend } from "../utils/api";
import { eventBus } from "../main";

export default {
    components: {
    },
    props: {
        dialog: {
            type: Boolean,
            required: true,
            default: false
        },
        selected_cover: {
            type: String,
            required: true,
            default: ''
        }
    },
    data: () => ({
        submitting: false,
        prospect: {
            main: {
                name: '',
                surname: '',
                phone: ''
                // marital_status: 'Single',
                // id_number: ''
            },
            dependents: [
                {
                    id: 1,
                    name: '',
                    surname: '',
                    marital_status: 'Single',
                    id_number: ''
                }
            ]
        }
    }),
    methods: {
        closeDialog() {
            eventBus.$emit('CLOSE_PERSONAL_COVER_SIGNUP_DIALOG');
        },
        addDependent() {
            const size = this.prospect.dependents.length;

            this.prospect.dependents.push({
                id: size + 1,
                name: '',
                surname: '',
                marital_status: 'Single',
                id_number: ''
            });
        },

        removeDependent() {
            this.prospect.dependents.pop();
        },

        resetForm() {
            this.submitting = false;
            this.prospect = {
                main: {
                    name: '',
                    surname: '',
                    phone: ''
                    // marital_status: 'Single',
                    // id_number: ''
                },
                dependents: [
                    {
                        id: 1,
                        name: '',
                        surname: '',
                        marital_status: 'Single',
                        id_number: ''
                    }
                ]
            };
        },

        async submitToServer() {
            if (
                this.prospect.main.name.trim().length === 0 ||
                this.prospect.main.surname.trim().length === 0 ||
                this.prospect.main.phone.trim().length === 0
            ) {
                emitAlert('Please capture all the details required');
                return;
            }

            this.submitting = true;
            const payloadObj = {
                type: 'PROSPECT_REG',
                prospect: {
                    product: this.selected_cover,
                    ...this.prospect.main
                }
            };

            try {
                // First create the business_partner
                const res = await submitToBackend(payloadObj);

                emitSuccess(res.message);
                this.resetForm();
                this.closeDialog();
            } catch (error) {
                this.submitting = false;
                console.log(error);
                if (error !== undefined) {
                    emitAlert(error.data.message);
                } else {
                    emitAlert('The server has taken too long in responding to your request');
                }

                return;
            }
        }
    },
    mounted() {
    },
    watch: {
        
    }
}
</script>
<style scoped>
.error-multi-line {
  white-space: pre-line;
}

</style>